<template lang="html">

    <div class="row">
        <div class="col-12">
        <h3>行事曆</h3>
        <div class="table_heading">
              <div class="col-md-4 col-12 offset-md-8" v-if="options.length > 0">
                <!-- <b-form-select v-model="selected" :options="options" size="md" class="mt-3"></b-form-select> -->
                <select v-model="selected" class="form-control" id="day_option" @change="getAnotherMonthData">
                    <option  :value="null" >選擇月份</option>
                    <option v-for="op in options" :selected="selected==op.value" v-bind:value="op.value" >{{ op.text}}</option>
                </select>
                <!-- selected : {{ selected}} -->
            </div>
        </div>
        <table class="table" id="table-breakpoint"  ref="myTable">
            <thead>
        <tr>
        <th >日期</th>
        <th >活動主題</th>
        <th >講員</th>
        <th >負責同工</th>
        <th >負責部門</th>
        </tr>
        </thead>
            <tbody>
            <tr v-for="item in filteredItems" :key="item.id">
                <td data-th="日期">{{item.start}}{{getWeekDays(item.start)}}
                    <template v-if="item.start !== item.end" class="float-left"> <br/>至<br/>{{item.end}}{{getWeekDays(item.end)}}</template>
                </td>
                <td class="left-bg" data-th="活動主題"><h6>{{item.title}}</h6></td>
                <td data-th="講員">{{item.speaker  || '--'}}</td>
                <td data-th="負責同工">{{item.colleagues || '--'}}</td>
                <td data-th="負責部門">{{item.department  || '--'}}</td>
            </tr>
            </tbody>
        </table>
        </div>
    </div>

</template>

<script>
import 'moment/locale/zh-hk';
import $ from 'jquery';
import {basictable} from  '.../../../public/template/ctheme/js/jquery.basictable.min.js';

export default {
    data() {
        return {
            selected:null,
            options: [],
            items: [],
            filteredItems: [],
        }
    },

    created() {

// let tag = document.createElement("script");
// tag.setAttribute("src", "/template/ctheme/js/jquery.basictable.min.js");
// document.head.appendChild(tag);

    },
    mounted() {
        // moment.locale('zh-hk');
        this.fetchOptions();
        this.fetchData(moment().year(), moment().month() + 1);

        this.$nextTick(() => {
           // window.$(this.$refs.myTable).basictable();
           $('#table-breakpoint').basictable({
             breakpoint: 768,
              tableWrap: false,
               forceResponsive: true,
           });
         });
    },

    methods: {
        getWeekDays(date){
            // const weekdays = ['日','一', '二','三', '四','五', '六'];
            // `(星期${weekdays[moment(date).weekday()]})`;
            return moment(date).format('dddd');
        },
        getAnotherMonthData(){

            if(this.selected !== null){
                // console.log("output selected", this.selected);
                const y = moment(this.selected).year();
                const m = moment(this.selected).month() + 1;
                // console.log("get another", m, y);
                this.fetchData(y, m);
            }
        },
        fetchOptions() {
            const url = `/church/calendar/getOptions`;
            axios.get(url).then(res => {
                if (res.data) {
                    // console.log("option response data", res.data);
                    let d = res.data;
                    let thisMonth = `${moment().year()}${("0" + (moment().month() + 1)).slice(-2)}`;
                    // console.log("thismonth ", thisMonth);
                    this.options.push({text: moment(thisMonth).lang('zh-hk').format("YYYY年MM月"),value: thisMonth });
                    for (var i of d) {
                        const op = {
                            text: moment(i).lang('zh-hk').format("YYYY年MM月"),
                            value: i
                        };
                        if(thisMonth != i){
                            this.options.push(op);
                        }
                    }
                    // console.log("options response data", this.options);
                }
            });
        },
        fetchData(year, month) {
            const url = `/church/calendar/getByMonth/${year}/${month}`;
            axios.get(url).then(res => {
                if (res.data) {
                    // console.log("calendar response data", res.data);
                    this.items = res.data;
                    this.filteredItems = res.data;
                }
            });
        },

    }
}
</script>

<style lang="css" scoped>
@media only screen and (max-width: 768px) {
    .table_heading{
        margin-top: 20px;
    }

    tbody td::before {
        content: attr(data-th) ": ";
        background: #79beed;
        color: #ffffff;
        margin-right: 10px;
        padding: 2px 10px;
        font-weight: normal !important;
    }
    table td {
        padding: 0;
    }
    table {
        /* border: 1px solid black; */
        /* padding-bottom:10px; */
    }
    tr{
        border-bottom: 2px solid #e4ebeb;
        margin-top:15px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/mlang/church/calendar/spring.vue